
import { Box, Button, Typography } from "@mui/material";

import { useState } from "react";
import CustomPaginationActionsTable from "./paginationTable";
import PaymentHistory from "./paymentHistory";

export default function ManageSubscription() {

    const [plans, setPlans] = useState("active_plans")
    const activePlans = [
        {
            plan: 'Base plan',
            description: 'ENT',
            details: "Cervical cancer is the 4th most common cancer in women globally, causing over 300,000 deaths each year. Cervical cancer is a tragedy not because it’s unavoidable, but because it’s preventable. Cervical cancer is one of the few cancers with a detectable precancer phase, making early detection critical.",
            benefits: ['500 SMS/month', '2 Users', '2 Locations'],
            price: 29.00,
            startedAt: '2025-05-01',
            lastBilledAt: '2025-07-01',
            nextBillingDate: '2025-08-01',
            status: "Active",
            cardDetails: {
                cardNumber: 'Visa xxx 9999',
                cardExpiry: "12/25"
            },
        },
        {
            plan: 'User Addons plan',
            description: 'Womens Health',
            details: "Cervical cancer is the 4th most common cancer in women globally, causing over 300,000 deaths each year. Cervical cancer is a tragedy not because it’s unavoidable, but because it’s preventable. Cervical cancer is one of the few cancers with a detectable precancer phase, making early detection critical.",
            benefits: ['1000 SMS/month', '4 users', '4 Locations'],
            price: 39.00,
            startedAt: '2025-02-23',
            lastBilledAt: '2025-04-14',
            nextBillingDate: '2025-05-14',
            status: "Active",
            cardDetails: {
                cardNumber: 'Visa xxxx 6255',
                cardExpiry: "07/26"
            },
        },

    ];

    const inActivePlans = [
        {
            plan: 'Base plan',
            description: 'ENT',
            details: "Cervical cancer is the 4th most common cancer in women globally, causing over 300,000 deaths each year. Cervical cancer is a tragedy not because it’s unavoidable, but because it’s preventable. Cervical cancer is one of the few cancers with a detectable precancer phase, making early detection critical.",
            benefits: ['500 SMS/month', '2 Users', '2 Locations'],
            price: 29.00,
            startedAt: '2024-01-01',
            lastBilledAt: '2024-06-01',
            nextBillingDate: null,
            status: "Inactive",
            cardDetails: {
                cardNumber: 'Visa xxx 1234',
                cardExpiry: "11/24"
            },

        },
        {
            plan: 'User Addons plan',
            description: 'Womens Health',
            details: "Cervical cancer is the 4th most common cancer in women globally, causing over 300,000 deaths each year. Cervical cancer is a tragedy not because it’s unavoidable, but because it’s preventable. Cervical cancer is one of the few cancers with a detectable precancer phase, making early detection critical.",
            benefits: ['1000 SMS/month', '4 Users', '4 Locations'],
            price: 39.00,
            startedAt: '2023-11-20',
            lastBilledAt: '2024-03-20',
            nextBillingDate: null,
            status: "Inactive",
            cardDetails: {
                cardNumber: 'Visa xxx 5678',
                cardExpiry: "08/25"
            },

        },
        {
            plan: 'Growth plan',
            description: 'Dermatology',
            details: "Cervical cancer is the 4th most common cancer in women globally, causing over 300,000 deaths each year. Cervical cancer is a tragedy not because it’s unavoidable, but because it’s preventable. Cervical cancer is one of the few cancers with a detectable precancer phase, making early detection critical.",
            benefits: ['2000 SMS/month', '10 Users', '10 Locations'],
            price: 49.00,
            startedAt: '2023-05-01',
            lastBilledAt: '2024-01-01',
            nextBillingDate: null,
            status: "Inactive",
            cardDetails: {
                cardNumber: 'Visa xxx 8765',
                cardExpiry: "04/25"
            },

        }
    ];

    const planOptions = [
        { id: "active_plans", label: "Active Plans" },
        { id: "inactive_plans", label: "Inactive Plans" },
        { id: "payment_history", label: "Payment History" },
    ];

    const buttonStyle = (id: string) => ({
        bgcolor: plans === id ? "primary.main" : "#fafafa",
        color: plans === id ? "white" : "primary.main",
        border: "1px solid #e5e5e5",
        py: "2px",
        px: "10px",
        borderRadius: "5px",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    });




    return (

        <Box sx={{ padding: "30px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", mx: "30px", my: "100px", borderRadius: "12px" }}>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    color: "primary.main",
                }}
            >
                Manage Subscriptions
            </Typography>

            

            <Box sx={{ my: "20px", display: "flex", alignItems: "center", gap: "5px" }}>

                {planOptions.map(({ id, label }) => (
                    <Button
                        key={id}
                        id={id}
                        sx={buttonStyle(id)}
                        onClick={(event) => setPlans(event.currentTarget.id)}
                    >
                        {label}
                    </Button>
                ))}

            </Box>

            <Box sx={{ mt: "60px" }}>
                {plans === "active_plans" && <CustomPaginationActionsTable data={activePlans} />}
                {plans === "inactive_plans" && <CustomPaginationActionsTable data={inActivePlans} />}
                {plans === "payment_history" && <PaymentHistory />}
            </Box>
        </Box>
    )
}
